import React, { FC, Fragment } from 'react';

import {
  Connect,
  PropsFromRedux,
} from './SearchResultPreparatoryWorkContainer';

import { PreparatoryWorkResultItem } from '../../../../components/search/preparatory-work/PreparatoryWorkResultItem';

import { useUser } from '../../../../user/useUser';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';

import { PreparatoryWorkHit } from '../../../search.types';

type Props = {
  hits: PreparatoryWorkHit[];
} & PropsFromRedux;

export const RawSearchResultPreparatoryWork: FC<Props> = ({
  hits,
  originalQueryKey,
}) => {
  const { accessPremium } = useUser();

  if (!hits) return null;

  const sendTrackingEvent = ({
    position,
    id,
    url,
    category,
    subCategory,
  }: {
    position: number;
    id: string;
    url: string;
    category: string;
    subCategory: string;
  }) => {
    doctrineAnalytics('Search ResultClicked', {
      type: 'preparatory_work',
      position,
      id,
      category,
      subCategory,
      url,
      original_query_key: originalQueryKey,
    });
  };

  return (
    <>
      {hits.map(
        ({
          preparatoryDocumentId: id,
          title,
          url,
          sectionAbstracts: abstract,
          position,
          category,
          subCategory,
        }) => (
          <Fragment key={id}>
            <PreparatoryWorkResultItem
              title={title}
              url={url}
              abstract={abstract}
              accessPremium={accessPremium}
              onClick={() =>
                sendTrackingEvent({ id, url, position, category, subCategory })
              }
              source="search-preparatory-work-item"
            />
          </Fragment>
        ),
      )}
    </>
  );
};

export const SearchResultPreparatoryWork = Connect(
  RawSearchResultPreparatoryWork,
);
